import { CATEGORY_GUIDES, SEO_NAMES } from "../../lib/catalog/categorySeo";

// Buyer's guide shown below the product grid on category pages.
export default function CategoryGuide({ handle }) {
  const guide = CATEGORY_GUIDES[handle];
  if (!guide) return null;
  return (
    <section
      data-testid="category-guide"
      className="mt-20 border-t border-[#1F1F1F] pt-12 max-w-[880px]"
    >
      <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">Buyer's guide</p>
      <h2 className="mt-3 font-display text-white text-[28px] md:text-[36px] leading-[1]">
        How to choose {SEO_NAMES[handle]?.toLowerCase() || handle}
      </h2>
      <div className="mt-8 space-y-8">
        {guide.sections.map((s) => (
          <div key={s.h}>
            <h3 className="font-mono text-[12px] uppercase tracking-[0.14em] text-white">{s.h}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-[#A3A3A3]">{s.p}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
